export const routes = {
  compare: '/compare',
  loanRequest: '/compare/loan',
  personalDetails: '/compare/personal-details',
  offers: '/compare/offers',
  offersUnavailable: '/compare/offers/unavailable',
  suggestions: '/compare/offers/suggestions',
  suggestionsSent: '/compare/offers/suggestions/sent',
  appFailed: '/compare/offers/unsuccessful',
  thankYou: '/compare/offers/thank-you',
  reportIssue: '/compare/report-issue',
  issueSent: '/compare/report-issue/sent',
  noEntry: '/compare/no-entry',
  otp: '/compare/otp',
  documents: '/compare/documents',
  applicationSubmitted: '/compare/application-submitted',
};
